export default () => ({
  messages: []
})



// WEBPACK FOOTER //
// ./src/store/modules/message/state.js